import { useCallback } from 'react';
import {
  useKeyValueSettingsMutation,
  updateCache
} from '~/modules/common/hooks';

export const RESOURCE_OVERVIEW_CHART_SETTINGS =
  'resource_overview_chart_settings';

export const useResourceOverviewChartSettingsMutation = () => {
  const [putKeyValueSettings] = useKeyValueSettingsMutation(
    updateCache(RESOURCE_OVERVIEW_CHART_SETTINGS)
  );

  const putChartSettings = useCallback(
    ({ scale }) => {
      putKeyValueSettings({
        variables: {
          input: {
            key: RESOURCE_OVERVIEW_CHART_SETTINGS,
            settings: {
              scale
            }
          }
        }
      });
    },
    [putKeyValueSettings]
  );

  return {
    putChartSettings
  };
};

export default useResourceOverviewChartSettingsMutation;
